import axios from "axios";
import router from "../../vue/router";
import { API_URL } from "../../const/api";
import store from "../../vue/store";
import { LOGOUT_USER, UPDATE_TOKENS } from "../../vue/store/const/actions-types";
import Cookies from "js-cookie";


// Source - https://stackoverflow.com/questions/59448621/laravel-vue-js-axios-csrf-token-mismatch
// Posted by Kevin Lynch
// Retrieved 04.11.2025, License - CC-BY-SA 4.0

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true

});

axiosInstance.interceptors.request.use(function (config) {
  const token = Cookies.get('XSRF-TOKEN');
  if (token) {
    config.headers['X-XSRF-TOKEN'] = token;
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

axiosInstance.interceptors.response.use((response) => {
      return Promise.resolve(response);
    },
    (error) => {
      const requestUrl = error.config.url;
      if (error.response && error.response.status === 401) {
        const isResetPasswordOTPRequest = requestUrl.includes('reset-password') || requestUrl.includes('reset-password');
        if (requestUrl === '/api/user/login' || requestUrl === '/user/login' || isResetPasswordOTPRequest) {
          return Promise.reject(error.response);
        }
        // return new AuthApi()
        //   .refreshToken(store.state.user.refreshToken)
        //   .then((r) => {
        //     const refreshToken = r.data.refresh_token;
        //     const accessToken = r.data.access_token;
        //     console.log(UPDATE_TOKENS);
        //     store.dispatch(UPDATE_TOKENS, {
        //       accessToken: accessToken,
        //       refreshToken: refreshToken,
        //     });
        //     error.config.headers["Authorization"] = `Bearer ${accessToken}`;
        //     return axios.request(error.config);
        //   })
        //   .catch(async (err) => {
        //     console.dir(err);
        //     console.log("error");
        //     // await store.dispatch(CLEAR_USER_DATA);
        //     // router.push({ name: "login" });
        //     return Promise.reject(error.response);
        //   });
        //window.location = "/login";
        store.dispatch(LOGOUT_USER).then(() => {
          router.push({ name: 'login' });
        });

        return Promise.reject(error.response);
      } else if (
          error.response.status === 403 &&
          error.config.url === "/user/login.otp"
      ) {
        return Promise.reject(error.response);
      } else if (error.config.url === "/user/refresh.token") {
        store.dispatch(LOGOUT_USER).then(() => {
          if (!["Login", "Registration"].includes(router.currentRoute.name)) {
            router.push({
              path: "/login",
              query: {
                last_refresh_time: new Date().to,
              },
            });
          }
        });
        return Promise.reject(error.response);
      } else if (error.response.status === 403 && error.config.url === '/api/login') {
        window.location.href = '/login/two-factor-authentication';
        return Promise.reject(error.response);
      } else {
        return Promise.reject(error.response);
      }
    }
);

export default axiosInstance;
